import React from 'react';
import { Box, Paper } from '@mui/material';
import Typography from '../i18n/LocalizedTypography';
import { useTranslation } from 'react-i18next';
import { getHouseShort } from '../../i18n/astrology';
import KpDataTable from './KpDataTable';

export default function KpAspectTables({ planetRows, houseRows, planetName, aspectText }: {
  planetRows: any[]; houseRows: any[]; planetName: (name: string) => string; aspectText: (name: string) => string;
}) {
  const { t } = useTranslation();
  const degrees = (value: number | string | null | undefined) => value == null || value === '' ? '—' : `${value}°`;
  return <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 625px), 1fr))', gap: 2 }}>
    {(['planets', 'houses'] as const).map(view => {
      const planets = view === 'planets';
      const rows = planets ? planetRows : houseRows;
      const title = t(planets ? 'kp.planetaryAspectTable' : 'kp.houseAspectTable');
      const identifier = t(planets ? 'kp.significatorPlanetHeader' : 'kp.significatorHouseHeader');
      return <Paper key={view} sx={{ p: 2, minWidth: 0 }}>
        <Typography variant="h6" sx={{ mb: 1.5 }}>{title}</Typography>
        {rows.length ? <KpDataTable label={title}
          headers={[`${identifier} 1`, `${identifier} 2`, t('kp.aspect'), t('kp.angle'), t('kp.orb')]}
          rows={rows.map((row, index) => ({ key: `${view}-${index}`, cells: [
            planets ? planetName(row.planet1) : getHouseShort(t, row.house1),
            planets ? planetName(row.planet2) : getHouseShort(t, row.house2),
            aspectText(row.aspect), degrees(row.aspectDegree), degrees(row.orb),
          ] }))} /> : <Typography color="text.secondary">{t('kp.noAspectData')}</Typography>}
      </Paper>;
    })}
  </Box>;
}
